export type Locale =
  | "en"
  | "ru"
  | "lv"
  | "es"
  | "de"
  | "fr"
  | "pl"
  | "it"
  | "pt"
  | "nl"
  | "cs"
  | "uk"
  | "tr"
  | "ro"
  | "hu"
  | "sv"
  | "fi"
  | "nb"
  | "da"
  | "lt"
  | "et"
  | "sk"
  | "hr"
  | "sl";

/** Native names for the language menu (same in every locale). */
export const LOCALE_NATIVE_LABELS: Record<Locale, string> = {
  cs: "Čeština",
  da: "Dansk",
  de: "Deutsch",
  et: "Eesti",
  en: "English",
  es: "Español",
  fr: "Français",
  hr: "Hrvatski",
  it: "Italiano",
  lv: "Latviešu",
  lt: "Lietuvių",
  hu: "Magyar",
  nl: "Nederlands",
  nb: "Norsk",
  pl: "Polski",
  pt: "Português (Brasil)",
  ro: "Română",
  ru: "Русский",
  sk: "Slovenčina",
  sl: "Slovenščina",
  fi: "Suomi",
  sv: "Svenska",
  tr: "Türkçe",
  uk: "Українська",
};

/** Locales ordered alphabetically by native label. */
export const LOCALES: Locale[] = (
  Object.keys(LOCALE_NATIVE_LABELS) as Locale[]
).sort((a, b) =>
  LOCALE_NATIVE_LABELS[a].localeCompare(LOCALE_NATIVE_LABELS[b], "en", {
    sensitivity: "base",
  }),
);
